import gql from "graphql-tag"

export default gql`
  mutation ($user_id: Int!) {
    requestPasswordReset(id: $user_id)
  }
`
